import React, { useEffect, useState } from 'react'
import { Image, OverlayTrigger, Stack, Tooltip } from 'react-bootstrap'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import profile_icon from 'src/assets/images/user-icon.svg'
import user_circle from 'src/assets/images/user-circle.svg'
import edit_icon from 'src/assets/images/edit-icon.svg'
import right_icon from 'src/assets/images/right-arrow.svg'
import add_profile_icon from 'src/assets/images/add-profile-black-icon.svg'
import { useDispatch, useSelector } from 'react-redux'
import { switchProfile } from 'src/api/authService'
import { studentNavItems, teacherNavItems } from 'src/utils/constants'

export default function MobileFooter() {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userDetails = useSelector((state) => state.userDetails)
  const token = window.localStorage.getItem('token')
  const { pathname } = useLocation()
  const [open, setOpen] = useState(false)
  const [profiles, setProfiles] = useState([])
  const [activeAccountInfo, setActiveAccountInfo] = useState({})
  const { profileType, lastName, firstName } = activeAccountInfo || {}
  const [sideNavItems, setSideNavItems] = useState([])

  const handleLogOut = () => {
    window.localStorage.removeItem('token')
    window.localStorage.setItem('logout-event', Date.now().toString())
    dispatch({ type: '', res: [] })
    navigate('/')
  }

  const handleSwitchProfile = async (details) => {
    const res = await switchProfile(details?.key)
    if (res?.status === 'SUCCESS') {
      window.localStorage.setItem('token', res?.token)
      dispatch({ type: 'set', res: res?.profiles || [] })
      setActiveAccountInfo(details)
      setOpen(false)
      navigate(`/${details.profileType.toLowerCase()}`)
    }
  }

  const handleProfile = () => {
    setOpen(false)
    navigate(`/${profileType.toLowerCase()}/profile`)
  }

  useEffect(() => {
    if (!token) handleLogOut()
    else {
      setActiveAccountInfo(userDetails[0])
      setProfiles(userDetails)
    }
  }, [userDetails])
  useEffect(() => {
    if (profileType === 'Student') setSideNavItems(studentNavItems)
    else if (profileType === 'Teacher') setSideNavItems(teacherNavItems)
  }, [profileType])

  return (
    <>
      <div className="position-relative z-3 w-100">
        <div className="mobile-footer">
          {sideNavItems.map((item, index) => (
            <OverlayTrigger
              key={index}
              placement="top"
              overlay={<Tooltip id={`tooltip-${index}`}>{item.title}</Tooltip>}
            >
              <Link
                to={item.to}
                onClick={() => {
                  if (pathname !== item.to) setOpen(false)
                }}
                className="nav-item"
              >
                <span className={`nav-icon ${pathname === item.to ? 'active' : ''}`}>
                  <Image src={item.icon} />
                </span>
              </Link>
            </OverlayTrigger>
          ))}
          <Image onClick={() => setOpen(!open)} src={profile_icon} />
        </div>
      </div>
      {/* <Collapse in={open}> */}
      <div className={`custom-nav-drawer ${open ? 'show mb-80 ' : ''}`}>
        <div className="profile-header">
          <div className="header-container">
            <div className="edit-profile-icon">
              <Image src={user_circle} width={130} height={130} />
              <div className="edit-icon" role="button" onClick={() => handleProfile()}>
                <Image src={edit_icon} />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-90 text-center">
          <h3 className="fw-semibold">{firstName + ' ' + lastName}</h3>
          <div className="profile-type">{profileType}</div>
        </div>
        <div className="py-20">
          <div
            className="px-20 footer-nav mb-1"
            onClick={() => {
              handleProfile()
            }}
          >
            View Profile
            <Image className="ms-auto" src={right_icon} />
          </div>
          <div className="px-20 footer-nav " onClick={handleLogOut}>
            Logout
          </div>
        </div>
        <div className="py-20">
          <small className="fw-semibold px-20 nav-page">Swich Profile</small>
          <Stack className="align-items-start">
            {profiles
              ?.filter((ele) => ele.key !== activeAccountInfo?.key)
              ?.map((ele) => (
                <Stack
                  role="button"
                  direction="horizontal"
                  gap={10}
                  className="align-items-center py-10 w-100 footer-profiles"
                  key={ele?.key}
                  onClick={() => handleSwitchProfile(ele)}
                >
                  <Image className="img-black" src={profile_icon} />

                  <div className="flex-column align-items-start">
                    <span className="sidebar-text text-truncate text-wrap">
                      {ele.firstName} {ele.lastName}
                    </span>
                    <small className="profile-type text-truncate">
                      {ele?.profileType === 'Teacher' && ele?.canVerifyTests
                        ? `${ele?.profileType} (v)`
                        : ele?.profileType}
                    </small>
                  </div>
                  <Image className="ms-auto img-black" src={right_icon} />
                </Stack>
              ))}
            <div
              key="add-profile"
              onClick={() =>
                navigate('/register', {
                  state: {
                    openDialog: true,
                  },
                })
              }
            >
              <div role="button" className="d-flex gap-10 align-items-center p-20">
                <Image src={add_profile_icon} />
                <span className="sidebar-text text-truncate text-wrap">Add Profile</span>
              </div>
            </div>
          </Stack>
        </div>
      </div>
    </>
  )
}
